import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import api from "./api";

Vue.config.productionTip = false;

api.setDefaults();
api.getContent().then(([menu, content]) => {
	store.cacheContent("menu", menu.data);
	content.data.forEach(item => {
		store.cacheContent(item.content_id, item);
	});

	new Vue({
		router: router(menu),
		store,
		render: h => h(App)
	}).$mount("#app");
});
